module.exports = __webpack_public_path__ + "img/dashboard_icon_on.d7c7deba.svg";